'use strict';
import * as $j_app$002eapi$002e$002dUsers$002dEdit$002dRequest$002dForm from "./app.api.-Users-Edit-Request-Form.js";
import * as $j_app$002edata$002e$002dOrganization$002dName$0024package$0024$002dOrganization$002dName$002dForm$0024 from "./app.data.-Organization-Name$package$-Organization-Name-Form$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$002dForm$0024 from "./app.data.-User-Details$package$-User-First-Name-Form$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$002dForm$0024 from "./app.data.-User-Details$package$-User-Last-Name-Form$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$002dForm$0024 from "./app.data.-User-Details$package$-User-Middle-Name-Form$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$002dForm from "./app.data.-User-Details-Form.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_UsersEditRequestForm$$anon$4() {
}
export { $c_Lapp_api_UsersEditRequestForm$$anon$4 as $c_Lapp_api_UsersEditRequestForm$$anon$4 };
$p = $c_Lapp_api_UsersEditRequestForm$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_UsersEditRequestForm$$anon$4;
/** @constructor */
function $h_Lapp_api_UsersEditRequestForm$$anon$4() {
}
export { $h_Lapp_api_UsersEditRequestForm$$anon$4 as $h_Lapp_api_UsersEditRequestForm$$anon$4 };
$h_Lapp_api_UsersEditRequestForm$$anon$4.prototype = $p;
$p.bYu = (function(src) {
  var $x_2 = new $j_app$002edata$002e$002dUser$002dDetails$002dForm.$c_Lapp_data_UserDetailsForm($j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$002dForm$0024.$m_Lapp_data_UserDetails$package$UserFirstNameForm$().aG().ak(src.Bl.z4), $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$002dForm$0024.$m_Lapp_data_UserDetails$package$UserMiddleNameForm$().aG().ak(src.Bl.z6), $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$002dForm$0024.$m_Lapp_data_UserDetails$package$UserLastNameForm$().aG().ak(src.Bl.z5));
  var this$1 = src.KC;
  if (this$1.c()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1 = this$1.g();
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002e$002dOrganization$002dName$0024package$0024$002dOrganization$002dName$002dForm$0024.$m_Lapp_data_OrganizationName$package$OrganizationNameForm$().aG().ak(arg1));
  }
  return new $j_app$002eapi$002e$002dUsers$002dEdit$002dRequest$002dForm.$c_Lapp_api_UsersEditRequestForm($x_2, $x_1);
});
$p.ak = (function(src) {
  return this.bYu(src);
});
var $d_Lapp_api_UsersEditRequestForm$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_UsersEditRequestForm$$anon$4, "app.api.UsersEditRequestForm$$anon$4", ({
  yM: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_api_UsersEditRequestForm$$anon$4 as $d_Lapp_api_UsersEditRequestForm$$anon$4 };
//# sourceMappingURL=app.api.-Users-Edit-Request-Form$$anon$4.js.map
